interface PageSEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: "website" | "article";
}

export default function PageSEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage,
  ogType = "website",
}: PageSEOProps) {
  const fullTitle = `${title} - 黑料网`;
  const desc = description.length > 160 ? description.slice(0, 157) + "..." : description;
  const kw = keywords || "黑料网,娱乐八卦,明星黑料,黑料百科";

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={ogType} />
      <meta property="og:locale" content="zh_CN" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:width" content="1600" />}
      {ogImage && <meta property="og:image:height" content="900" />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      <meta name="robots" content="index, follow" />
    </>
  );
}